import React from "react"
import Link from "gatsby-link"
import SEO from '../components/SEO'
import SVGInline from 'react-svg-inline'


class Page extends React.Component {
  render() {
    const pageSEO = {
      title: "Legislatie administarre imobile",
      description: "Am pregatit pentru dvs legislatia in vigoare cu privire la administrarea de imobile.",
      path: "/legislatie/"
    };
    return (
      <div className="o-page__content">
        <SEO pageSEO={pageSEO} />
        <div className="c-section-gradient">
          <div className="o-container u-pv-20 u-pv-30@tablet u-text-center@tablet">
            <h1 className="c-page__heading">Legislatie administrare imobile</h1>
          </div>
        </div>

        <div className="o-container u-pv-20 u-pv-30@tablet u-bg-white">
          <div className="o-container o-container--text u-ph-0">

            <p className="u-text-center u-mb-30 u-color-grey-500">Nicad Admin Imob va pune la dispozitie resurse utile privind legislatia administrarii imobilelor.</p>

            <a className="c-resource" href="/legislatie/OUG_18_2009_reabilitare_termica_cresterea_performantei_energetice_a_blocurilor_de_locuinte.pdf" download>
              <div className="c-resource__icon">
                <div className="c-resource__icon-extention">pdf</div>
              </div>
              <span className="c-resource__name">OUG 18/2009 reabilitare termica cresterea performantei energetice a blocurilor de locuinte</span>
            </a>
            <a className="c-resource" href="/legislatie/Norma metodologica nr 17 din 2009.docx" download>
              <div className="c-resource__icon">
                <div className="c-resource__icon-extention">doc</div>
              </div>
              <span className="c-resource__name">Norma metodologica nr 17 din 2009</span>
            </a>
            <a className="c-resource" href="/legistatie/legea 61 din 27 sept 1991.pdf" download>
              <div className="c-resource__icon">
                <div className="c-resource__icon-extention">pdf</div>
              </div>
              <span className="c-resource__name">LEGE nr. 61 din 27 septembrie 1991</span>
            </a>
            <a className="c-resource" href="/legislatie/LEGEA nr 230.docx" download>
              <div className="c-resource__icon">
                <div className="c-resource__icon-extention">doc</div>
              </div>
              <span className="c-resource__name">LEGEA nr. 230/2007, actualizata 2017, privind infiintarea, organizarea si functionarea asociatiilor de proprietari</span>
            </a>
            <a className="c-resource" href="/legislatie/LEGE nr.114 din 1996 privind locuintele.pdf" download>
              <div className="c-resource__icon">
                <div className="c-resource__icon-extention">pdf</div>
              </div>
              <span className="c-resource__name">LEGE nr. 114 din 11 octombrie 1996 privind locuintele</span>
            </a>
            <a className="c-resource" href="/legislatie/HOTARARE nr.609 din 2007 pentru modificarea art. 2 alin. (2) din Hotararea Guvernului nr. 933 din 2004 .pdf" download>
              <div className="c-resource__icon">
                <div className="c-resource__icon-extention">pdf</div>
              </div>
              <span className="c-resource__name">HOTARARE nr. 609 din 20 iunie 2007</span>
            </a>
            <a className="c-resource" href="/legislatie/HG_1588.pdf" download>
              <div className="c-resource__icon">
                <div className="c-resource__icon-extention">pdf</div>
              </div>
              <span className="c-resource__name">HOTARÂRE Nr. 1588 din 19 decembrie 2007 </span>
            </a>

          </div>
        </div>
      </div>
    )
  }
}

export default Page





// WEBPACK FOOTER //
// ./src/pages/legislatie.js